import { useQuery } from 'react-query';
import axios from '../../../utils/axios';
import { apiurl } from '../../../config/apiUrl';

const fetchAgencyPOConfig = async (params = {}) => {
  const { companyId, expenseCategoryId } = params;
  if (companyId == null || companyId === '' || expenseCategoryId == null || expenseCategoryId === '') {
    return Promise.reject(new Error('companyId and expenseCategoryId are required'));
  }
  const searchParams = new URLSearchParams({
    companyId: String(companyId),
    expenseCategoryId: String(expenseCategoryId)
  });
  const url = `${apiurl?.getAgencyPOConfig}?${searchParams.toString()}`;
  const response = await axios.get(url);
  return response;
};

const getAgencyPOConfig = (params = {}, options = {}) => {
  const { companyId, expenseCategoryId } = params;
  const enabled = Boolean(
    companyId != null && companyId !== '' && expenseCategoryId != null && expenseCategoryId !== ''
  );

  return useQuery(
    ['getAgencyPOConfig', companyId, expenseCategoryId],
    () => fetchAgencyPOConfig({ companyId, expenseCategoryId }),
    {
      enabled: enabled && (options?.enabled !== false),
      refetchOnWindowFocus: false,
      ...options
    }
  );
};

export default getAgencyPOConfig;
